import { Cloudinary } from '@cloudinary/url-gen';
import { CloudinaryComponentProps } from 'cloudinary-react';
import { BaseMediaFragment, MediaTypeCodeEnum } from '@minecraft.graphql-operations';
import { getEnvironment } from '@minecraft.environment';
import { gqlMedia, gqlMediaStatus, gqlMediaTypeCodeEnum as MEDIA_TYPE } from '@minecraft.graphql-types';
import { helpers } from '@minecraft.utils';

export const cloudinaryEnvironment = () => ({
  hotStorageCloudName: getEnvironment().CN_HOT_CLOUDNAME,
  coldStorageCloudName: getEnvironment().CN_COLD_CLOUDNAME,
  domain: getEnvironment().CLD_DOMAIN,
});

export type sizeType = 'xxsm' | 'xsm' | 'sm' | 'md' | 'modal' | 'lg';

// [width, height]
export const sizes: Record<sizeType, [number, number]> = {
  xxsm: [50, 40],
  xsm: [144, 81],
  sm: [256, 144],
  md: [353, 199],
  modal: [560, 315],
  lg: [704, 396],
};

export const audioPlayerHeight = 47;

export type VideoAudioThumbnail = {
  url?: string;
  fileKey?: string;
  transformation?: Omit<BaseMediaFragment['transformation'], '__typename'>;
  mediaType?: { code: string };
  mediaStorageStatus?: { code: string };
  mediaStatus?: { code: string };
};

export type CloudinaryVideoAudioProps = Omit<CloudinaryComponentProps, 'transformation'> & {
  /** set video elements to play as soon as they are able */
  autoPlay?: boolean;
  guid?: string; // publicId
  isThumbnail?: boolean;
  mediaType: MEDIA_TYPE | MediaTypeCodeEnum;
  mediaStatus?: gqlMediaStatus['code'];
  mediaStorageStatus: gqlMedia['mediaStorageStatus']['code'];
  // Deprecated, remove all usage.
  thumbnailUrl?: string;
  customSize?: [number, number] | number[];
  type?: sizeType;
  url?: string;
  withDownloadLink?: boolean;
  hidePlayIcon?: boolean;
  preload?: string;
  thumbnailOffset?: number | 'auto';
  fileKey?: string;
  controlsList?: string;
  thumbnail?: VideoAudioThumbnail;
  isVisible?: boolean;
  responsiveWidth?: boolean;
  'data-qa-id'?: string;
  'data-testid'?: string;
  title?: string;
};

export const getCloud = (media: Pick<CloudinaryVideoAudioProps, 'mediaStorageStatus'>) =>
  helpers.isMediaInColdStorage(media.mediaStorageStatus)
    ? new Cloudinary({ cloud: { cloudName: cloudinaryEnvironment().coldStorageCloudName } })
    : new Cloudinary({ cloud: { cloudName: cloudinaryEnvironment().hotStorageCloudName } });
